import { useRef, useCallback, useEffect } from 'react';
import { getAudioForUserFromDB } from 'utils/indexedDBService';
import { performAssessmentHooks } from '..';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'store';

const usePerformSyncUploads = () => {
    const dispatch = useDispatch()
    const { user } = useSelector(state => state.user);
    const uploadRecord = performAssessmentHooks.useUploadFile();

    // שמירת הפונקציה הקיימת של העלאה
    const uploadRecordRef = useRef(uploadRecord);

    useEffect(() => {
        uploadRecordRef.current = uploadRecord;
    }, [uploadRecord]);

    // זו הפונקציה היזומה שמבצעת את פעולת הסנכרון
    const performSync = useCallback(async () => {
        if (!user || !user.user_id) {
            return;
        }

        try {
            const pendingUploads = await getAudioForUserFromDB(user.user_id);

            if (!pendingUploads || pendingUploads.length === 0) {
                dispatch(actions.setStuckAssessmentIds([]));
                return;
            }

            console.log(`נמצאו ${pendingUploads.length} קבצים ממתינים, מתחיל העלאת רקע...`);

            // 1. חילוץ כל מזהי המבדקים למערך אחד
            const assessmentIds = pendingUploads.map(item => item.key.split('_').pop());

            // 2. עדכון ה-Store במערך המלא של המבדקים התקועים
            dispatch(actions.setStuckAssessmentIds(assessmentIds));

            for (const item of pendingUploads) {
                const assessmentId = item.key.split('_').pop();
                const mockAssessment = { id: assessmentId };

                try {
                    await uploadRecordRef.current(mockAssessment, item.blob, true);
                } catch (err) {
                    console.error(`שגיאה בהעלאת רקע של מבדק ${assessmentId}`, err);
                }
            }

            console.log("סנכרון רקע הסתיים.");

        } catch (error) {
            console.error("שגיאה בגישה למסד הנתונים המקומי", error);
        }
    }, [user?.user_id]);

    return performSync;
}

export default usePerformSyncUploads